<template>
  <div>
    <!-- <div class="bg-color-red userform_top"></div> -->
    <div class="userform">
      <div v-if="studentApply">
        <div class="tips"><span>*&nbsp;</span>手机号</div>
        <div class="userform_item">
          <input type="text" placeholder="请输入手机号" v-model="formInfo.number" />
        </div>
        <div class="uploader_form">
          <div class="tips"><span>*&nbsp;</span>订单截图</div>
          <div class="upload acea-row row-middle">
            <div class="pictrue" v-for="(img, index) in formInfo.order_image" :key="img">
              <img :src="img" />
              <div class="iconfont icon-guanbi1 font-color-red" @click="formInfo.order_image.splice(index, 1)"></div>
            </div>
            <VueCoreImageUpload class="btn btn-primary" :crop="false" compress="80" @imageuploaded="imageuploaded"
              :headers="headers" :max-file-size="5242880" :credentials="false" inputAccept="image/*" inputOfFile="file"
              :url="url" v-if="formInfo.order_image.length < 1">
              <div class="pictrue acea-row row-center-wrapper row-column">
                <span class="iconfont icon-icon25201"></span>
                <div>上传照片</div>
              </div>
            </VueCoreImageUpload>
          </div>
        </div>
        <button class="userform_submit bg-color-red" @click="userformsubmit()">
          提交申请
        </button>
      </div>
      <div v-else class="apply-success">
        <h3>{{studentTitle}}</h3>
        <p>请长按识别二维码，联系客服领取学习资料</p>
        <div class="apply-success-img">
          <img :src="csURL" alt="">
        </div>
      </div>
    </div>
  </div>
</template>
<script>

import {
  studyApply,getCsQrcode
} from "@api/user";
import { VUE_APP_API_URL } from "@utils";
import VueCoreImageUpload from "vue-core-image-upload";
import 'vant/lib/radio/style';
import 'vant/lib/radio-group/style';

export default {
  name: "studyApply",
  components: {
    VueCoreImageUpload,
  },
  data: function () {
    return {
      // 图片上传
      url: `${VUE_APP_API_URL}/upload/image`,
      headers: {
        "Authori-zation": "Bearer " + this.$store.state.app.token
      },
      formInfo: {
        number: '',
        order_image: []
      },
      applyInfo: {},
      studentApply:true,
      studentTitle:'',
      csURL:''
    }
  },
  watch: {},
  mounted() {
    this.getCSImg()
  },
  methods: {
    imageuploaded(res) {
      if (res.status !== 200) return this.$dialog.error(res.msg || "上传图片失败");
      this.formInfo.order_image.push(res.data.url);
    },

    // 获取客户二维码
    getCSImg(){
      getCsQrcode().then(res => {
        res.data.forEach(item => {
            if (item.id == 210) {  //牛津绿客服
              this.csURL = item.qrcode;
            }
        });
      })
    },

    /**
      * 手机号校验
    */
    validPhone(phone) {
      if (
        !/^((13[0-9])|(14[5-9])|(15([0-3]|[5-9]))|(16[6-7])|(17[1-8])|(18[0-9])|(19[1|3])|(19[5|6])|(19[8|9]))\d{8}$/.test(phone)
      ) {
        return false
      } else {
        return true
      }
    },

    //提交申请   
    async userformsubmit() {
      console.log(this.formInfo);

      let that = this

      if (this.formInfo.number == '') return this.$dialog.message("请填写手机号");
      if (!this.validPhone(this.formInfo.number)) return this.$dialog.message("手机格式错误");

      if (this.formInfo.order_image.length == 0) {
        this.$dialog.message("请上传订单截图！")
        return;
      }

      studyApply(this.formInfo).then(res => {
        this.$dialog.message(res.msg);
        if (res.status == 200) {
            this.studentApply = false
        }
        this.studentTitle = res.msg
      })
        .catch(res => {
          if (res.data.status === 402) {
            this.$dialog.error(res.msg);
          } else if (res.data.status === 400) {
            this.$dialog.error(res.msg);
          }
          this.$dialog.error(res.msg);
        });
    }
  },
}
</script>

<style scoped>

.apply-success h3{
  font-size:26px  !important;
  padding: 5px 0;
  text-align: center;
  color: #000;
  font-weight: bold;
}
.apply-success p{
  font-size: 14px;
  text-align: center;
}
.apply-success-img{
  width: 240px;
  height: 240px;
  margin:  20px auto;
}
.apply-success-img img{
  width: 100%;
  height: 100%;
}


h4 {
  font-size: 12px;
  padding: 0.35rem 0;
  color: red;
}

.uploader_form {
  margin-bottom: 1.6em;
}

.uploader_form .upload .pictrue {
  margin-right: .22rem;
  width: 1.56rem;
  height: 1.56rem;
  position: relative;
  font-size: 0.24rem;
  color: #bbb;
  border: 1px solid #bbb
}

.uploader_form .upload .pictrue img {
  width: 100%;
  height: 100%
}

.uploader_form .upload .pictrue .icon-guanbi1 {
  position: absolute;
  font-size: 0.45rem;
  top: -0.1rem;
  right: -0.1rem;
  width: 0.45rem;
  height: 0.45rem;
  line-height: 0.45rem
}

.userform_top {
  width: 100%;
  height: 150px;
  position: absolute;
  top: 0;
  left: 0;
  z-index: 999;
  background: linear-gradient(0deg, #434343, #000000);
  background: -webkit-linear-gradient(0deg, #434343, #000000);
  background: -moz-linear-gradient(0deg, #434343, #000000);
  background: -ms-linear-gradient(0deg, #434343, #000000)
}

.userform {
  font-size: 15px;
  box-sizing: border-box;
  padding: 1.6em;
  color: #000;
  position: relative;
  z-index: 1000
}


.userform .userform_item {
  width: 100%;
  margin: 0 auto;
  margin-bottom: 1.6em;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative
}

.userform .userform_item_red:before {
  content: "*";
  display: block;
  padding: 0 0.4em;
  color: rgb(223, 53, 53);
  position: absolute
}


.userform .userform_item_agent {
  border-bottom: 1px solid #80cdd4;
  color: #80cdd4
}

.userform .userform_item_agent .agent_level_info {
  width: 100%;
  display: flex;
  justify-content: space-between;
  line-height: 2.4em;
  padding-left: 1.2em
}

.userform .userform_item_agent .agent_level_child {
  box-sizing: border-box;
  width: 100%;
  position: absolute;
  top: 2.4em;
  z-index: 1000;
  color: #000;
  background: #ffffff;
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
  line-height: 2em;
  padding: 1em;
  border-radius: 0 0 4px 4px;
  border-top: 1px solid #80cdd4
}

.userform .userform_item_agent .agent_level_name span {
  display: inline-block;
  color: #80cdd4;
  font-weight: 600;
  margin-right: 0.3em
}


.userform .userform_item input,
.userform .userform_item textarea {
  width: 100%;
  display: block;
  background: #f5f5f5;
  border-radius: 4px;
  color: #000;
  line-height: 1.6em;
  padding: 0.6em 0.6em
  bo
}

.userform .userform_item input {
  line-height: 2.4em;
  padding: 0 1em
}

.userform .userform_item_textarea.userform_item {
  align-items: flex-start
}

.userform .userform_item_bottom {
  display: flex
}

.userform .userform_item .userform_agreement {
  display: flex
}

.userform .userform_item .userform_agreement span {
  color: #80cdd4
}


.userform_submit {
  margin: 0 auto;
  display: block;
  width: 80%;
  line-height: 2.4em;
  border-radius: 1.2em;
  background: linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -webkit-linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -moz-linear-gradient(90deg, #80cdd4, #80cdd4);
  background: -ms-linear-gradient(90deg, #80cdd4, #80cdd4);
  text-align: center;
  font-weight: 600;
  color: #452f0d
}

.tips {
  font-size: .3rem;
  color: #000;
  margin-bottom: .2rem
}

.tips span {
  color: rgb(223, 53, 53)
}


.van-popup.van-popup--center {
  border-radius: 10px
}

</style>
<style>
.agreement-content * {
  word-break: break-all
}
</style>
